var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChef(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.208 20C6.06645 19.9993 5.93124 20.0586 5.83593 20.1633C5.74061 20.2679 5.69412 20.4081 5.708 20.549L5.913 22.649C5.98692 23.4178 6.63465 24.0035 7.407 24H16.593C17.3656 24.0023 18.0126 23.4152 18.085 22.646L18.285 20.546C18.2989 20.4051 18.2524 20.2649 18.1571 20.1603C18.0618 20.0556 17.9266 19.9963 17.785 19.997L6.208 20Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.846 8.19001C22.5131 6.9686 21.6588 5.95597 20.511 5.42201C19.9581 5.15773 19.3565 5.01097 18.744 4.99101C18.5289 4.98587 18.3412 4.84369 18.278 4.63801C17.4305 1.8814 14.8839 0.00012207 12 0.00012207C9.11606 0.00012207 6.56949 1.8814 5.722 4.63801C5.6588 4.84369 5.47111 4.98587 5.256 4.99101C4.64352 5.01086 4.04183 5.15762 3.489 5.42201C2.34092 5.95618 1.48666 6.96923 1.154 8.19101C0.792282 9.51225 1.0682 10.9266 1.9 12.015C2.58225 12.8969 3.57086 13.4905 4.67 13.678C4.89116 13.7169 5.05925 13.8985 5.081 14.122L5.464 18.049C5.48929 18.3059 5.70591 18.5012 5.964 18.5H18.036C18.2941 18.5012 18.5107 18.3059 18.536 18.049L18.919 14.122C18.9408 13.8985 19.1088 13.7169 19.33 13.678C20.4291 13.4905 21.4177 12.8969 22.1 12.015C22.932 10.9263 23.2079 9.51156 22.846 8.19001Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChef);
export default __webpack_public_path__ + "static/media/chef.a5f67118.svg";
export { ForwardRef as ReactComponent };